<div class="root" cdkDrag (cdkDragMoved)="onDragMove($event)" (cdkDragEnded)="onDragEnded($event)">
  <ng-content></ng-content>
</div>
